import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import { useAuth0 } from "../services/auth"

import purpleLotus from '../assets/images/illustrations/lotus_purple.png';

export default function TopNav({headerOpen, toggleSidebar}) {
  const { isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const [active, setActive] = useState(false);
  useEffect(()=>{
    const navbar = document.getElementById("navbar");
    const onScroll = window.addEventListener("scroll", () => {
      if (window.pageYOffset > 50) {
        navbar.style.background="#fff";
        navbar.style.boxShadow="0 0 2rem 0 rgb(41 48 66 / 10%)";
      } else {
        navbar.style.background="#E6F1FF";
        navbar.style.boxShadow="none";
      }
    });
    return ()=> window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav id="navbar" className="navbar fixed-top navbar-expand">
      <div className="w-100 sidemenu">
        <div className="toggle" onClick={()=>toggleSidebar(!headerOpen)} >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div className="sidemenu-main">
          <div className="sidemenu-left">
            <a href="#" className="btn btn-primary cta" target="_blank">Get started for free <i className="fas fa-chevron-right" /></a>
            <ul>
              <li>
                <h3><a href="">How it Works</a></h3>
              </li>
              <li>
                <h3><a href="">Our Story</a></h3>
              </li>
              <li>
                <h3><a href="plans.html">Plans</a></h3>
              </li>
              <li>
                <h3><a href="">FAQs</a></h3>
              </li>
              <li className="small-links">
                <a href="" onClick={() => loginWithRedirect({})}>Sign up</a>
              </li>
              <li>
                <a href="" onClick={() => loginWithRedirect({})}>Sign in</a>
              </li>
              <li>
                <a href="homepage_provider.html">For Providers</a>
              </li>
            </ul>
            <footer className="d-flex justify-content-between align-items-end">
              <img src={purpleLotus} alt="purple lotus" />
            </footer>
            <div className="sidemenu-image-container">
            </div>
          </div>
          <div className="sidemenu-right">
            <div className="sidemenu-overlay" />
          </div>
        </div>

      </div>
      <div className="mx-auto">
        <Link className="navbar-brand mx-auto" to="/">Healify</Link>
      </div>
      <div className="navbar-collapse collapse w-100">
        <ul className="navbar-nav ml-auto flex-end d-none d-sm-flex" style={{flexBasis: '100%', justifyContent: 'flex-end'}}>
          <li className="nav-item">
            <a className="nav-link" href="#">For Providers</a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="#" onClick={() => loginWithRedirect({role: 'patient'})}>Sign In</a>
          </li>
        </ul>
      </div>
    </nav>

  );
}
